
import { defineComponent } from 'vue';
import { useList } from '@/hooks/use-list';
import CustomTable from '@/components/custom-table';
import { renderColumns } from './composables/tableData';
import { formatTime } from '@toy/utils';
import { IZoneParseLogListReq, IZoneParseLogListResListItem } from '@/api/domain-system/type';
import { getZoneParseLogList } from '@/api/domain-system';

interface IZoneParseLogListReqDat extends IZoneParseLogListReq {
  dateRange?: string[];
}

export default defineComponent({
  name: 'DomainLogList',
  components: {
    CustomTable,
  },
  setup() {
    // 获取列表数据
    const {
      params,
      tableTotal,
      tableData,
      tableLoading,
      handleSearch,
      handleReset,
      handleSizeChange,
      handleCurrentChange,
    } = useList<IZoneParseLogListResListItem, IZoneParseLogListReqDat>({
      request: {
        api: getZoneParseLogList,
        params: {
          dateRange: [],
          createdTimeStart: '',
          createdTimeEnd: '',
          pageNum: 1,
          pageSize: 20,
        },
        handleParams: (paramsObj) => {
          if (
            paramsObj.dateRange
            && paramsObj.dateRange.length === 2
          ) {
            [paramsObj.createdTimeStart, paramsObj.createdTimeEnd] = [
              `${formatTime(paramsObj.dateRange[0], 'YYYY-MM-DD')} 00:00:00`,
              `${formatTime(paramsObj.dateRange[1], 'YYYY-MM-DD')} 23:59:59`,
            ];
          }
          delete paramsObj.dateRange;
          return paramsObj;
        },
      },
    });
    handleSearch();

    return {
      renderColumns,
      params,
      tableTotal,
      tableData,
      tableLoading,
      handleSearch,
      handleReset,
      handleSizeChange,
      handleCurrentChange,
    };
  },
});
